import {
  ColumnChartProps,
  columnChartOptions,
} from '@features/campaigns/subdomains/visitation/configuration/columnChartOptions';
import { Stack } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ChartTitle } from './ChartTitle';

type ColumnChartWithHeaderProps = {
  title: string;
  chartProps: ColumnChartProps;
};

export const ColumnChartWithHeader = (props: ColumnChartWithHeaderProps) => {
  return (
    <Stack direction="column" gap="1rem">
      <ChartTitle title={props.title} />
      <HighchartsReact
        highcharts={Highcharts}
        options={columnChartOptions(props.chartProps)}
      />
    </Stack>
  );
};
